import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { useParams } from "react-router-dom";
import locale from "locale";
import { Breadcrumb, Button, ButtonToolbar, Col, Row } from "react-bootstrap";
import { LinkContainer } from "react-router-bootstrap";

import { requestGetRecipientsStatistic, requestSendRecipientMail } from "../../../../api/cp";
import ReminderRecipientsTable from "./components/RemindersRecipientsTable";

const ReminderRecipientsStatictics = ({ event }) => {
    const { reminderId } = useParams();
    const [recipients, setRecipients] = useState([]);
    const BACK_LINK = `/event/${event.eventPassword}/edit-reminders`;
    const DOWNLOAD_LINK = `/api/cp/notifier/${reminderId}/recipient/statistic.xlsx`;

    useEffect(fetchRecipientsStatistics, []);

    async function fetchRecipientsStatistics() {
        try {
            const response = await requestGetRecipientsStatistic(reminderId);
            setRecipients(response);
        } catch (error) {
            alert(
                error?.error?.message ??
                error?.message ??
                "Error onShowStatistic"
            );
        }
    }

    const handleSendMail = async (id) => {
        try {
            await requestSendRecipientMail(id);
        } catch (error) {
            alert(
                error?.error?.message ??
                error?.message ??
                "Error onShowStatistic"
            );
        }
    };

    return (
        <section>
            <Row>
                <Col>
                    <Breadcrumb>
                        <LinkContainer to={`/event/${event.eventPassword}`}>
                            <Breadcrumb.Item>
                                {locale("reminders.broadcast")}
                            </Breadcrumb.Item>
                        </LinkContainer>
                        <LinkContainer to={BACK_LINK}>
                            <Breadcrumb.Item>
                                {locale("reminders.mailing")}
                            </Breadcrumb.Item>
                        </LinkContainer>
                        <Breadcrumb.Item active>Список получателей</Breadcrumb.Item>
                    </Breadcrumb>
                </Col>
            </Row>

            <Row>
                <Col xs={12}>
                    <ButtonToolbar>
                        <LinkContainer to={BACK_LINK}>
                            <Button>{locale("reminders.back")}</Button>
                        </LinkContainer>
                    </ButtonToolbar>
                </Col>
            </Row>

            <Row>
                <Col xs={12} style={{ marginTop: '1rem' }}>
                    <ButtonToolbar>
                        <a href={DOWNLOAD_LINK} style={{ textDecoration: 'none', color: 'inherit' }}>
                            <Button bsStyle="success">
                                Скачать
                            </Button>
                        </a>
                    </ButtonToolbar>
                </Col>
            </Row>

            <ReminderRecipientsTable
                recipients={recipients}
                onSendMail={handleSendMail}
            />
        </section>
    );
};

const mapStateToProps = (store) => ({
    event: store.currentEvent,
});

export default connect(mapStateToProps)(ReminderRecipientsStatictics);
